import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { AccountSecurityPage } from '@/areas/settings/Settings/AccountSecurityPage/AccountSecurityPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/settings/_menu/user/account-security')({
    staticData: { access: { permissions: ['view:organization_settings'] }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <AccountSecurityPage />;
}
